import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const SendBulkSMS = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default SendBulkSMS;
